import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import type { ImageProps } from "next/image";
const shouldSkipOptimization = (src: string): boolean => src.startsWith("http://") || src.startsWith("https://") || src.startsWith("data:") || src.endsWith(".svg");
interface AppImageProps extends ImageProps {
  src: string;
}
export function AppImage(t0) {
  const $ = _c(11);
  let props;
  let src;
  let unoptimized;
  if ($[0] !== t0) {
    ({
      src,
      unoptimized,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = src;
    $[3] = unoptimized;
  } else {
    props = $[1];
    src = $[2];
    unoptimized = $[3];
  }
  let t1;
  if ($[4] !== src || $[5] !== unoptimized) {
    t1 = unoptimized ?? shouldSkipOptimization(src);
    $[4] = src;
    $[5] = unoptimized;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== src || $[9] !== t1) {
    t2 = <Image src={src} unoptimized={t1} {...props} />;
    $[7] = props;
    $[8] = src;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}